import { IconProps } from './interfaces';

export const IconTikTok = ({ className }: IconProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={className}>
            <path d="M15.4189 9.67529L15.4119 15.2588C15.4472 17.7859 14.0354 20.2706 11.4025 20.7718C10.6613 20.9129 9.99777 20.9271 8.88247 20.68C2.45189 18.7529 4.59071 9.21647 11.0495 10.24C11.0495 13.3176 11.0495 10.24 11.0495 13.3176C8.3813 12.9224 7.49189 15.1459 8.19777 16.7341C8.84012 18.1812 11.5013 18.4918 12.426 16.4518C12.5319 16.0494 12.5813 15.5976 12.5813 15.0824V4H15.4189V4.01412C15.4189 4.26824 15.4966 7.98824 19.3931 8.21412C19.3931 11.6729 19.3931 8.21412 19.3931 11.0871C19.1037 11.1012 16.8307 10.9388 15.4189 9.67529Z" />
        </svg>
    );
};
